/* eslint-disable no-unused-vars,camelcase,no-console */
function gonative_onesignal_info(deviceInfo) {
  window.oneSignal = {deviceInfo};
}

window.gonative_onesignal_info = gonative_onesignal_info;
